/**
 * @param map
 */
export default function getProps(map: any){
	return function get(props: any, component: any, options: any, pathProps: any = null){
		let getInitialProps = component?.getInitialProps;
		let newProps = {...props, ...options, component, getInitialProps}
		if(pathProps){
			Object.assign(newProps, { path: map(pathProps) })
		}
		return newProps
	}
}
